module.exports = __webpack_public_path__ + "static/media/left-guy.1ca4c290.png";